export const lang = {
  language: 'English',
  yes: 'yes',
  no: 'no',
  yes1: '是',
  no1: '否',
  tip: 'tips',
  tips: '提示',
  languageTip: 'Are you sure to change to English?',
  conferenceTime: '会议登记截止时间',
  conferencePlace: '会议地点',
  conferenceIntroduction: '会议议程',
  conferenceTheme: '会议介绍',
  conferenceNews: '会议资讯',
  introductionOfExperts: '演讲嘉宾',
  conferenceCallForPapers: '会议征文',
  registration: '参会登记及管理',
  questionnaire: '会议满意度调查',
  register: '立刻登记',
  agenda: '会议议程',
  more: '查看更多',
  themes: '征文主题',
  deadline: '截止时间',
  guidelines: '征文须知',
  paperReview: '征文评审',
  submitPaper: '征文提交',
  submitPersonalPaper: '个人征文提交',
  submitorGanizationPaper: '组织征文提交',
  certificate: '提取论文录用证书',
  query: '登记信息查询',
  modify: '登记信息修改',
  pay: '会议缴费或上传缴费凭证',
  refund: '申请退费',
  signIn: '会议签到',
  sign: '签到',
  invoice: '预约开票',
  confirmationInformation: '请先确认参会人员信息',
  name: '姓名',
  nameOfParticipant: '报名人姓名',
  nameHint: '请输入姓名',
  cannotBeEmpty: '该选项不能为空哦~',
  nameCannotBeEmpty: '姓名不能为空哦~',
  phone: '手机号码',
  phoneOfParticipant: '报名人电话/邮箱',
  phoneCannotBeEmpty: '手机号码不能为空哦~',
  correctPhone: '请输入正确的手机号码哦~',
  emailCannotBeEmpty: '电子邮箱不能为空哦~',
  correctEmail: '请输入正确的电子邮箱哦~',
  idsCannotBeEmpty: '身份证/护照不能为空哦~',
  correctIds: '请输入正确的身份证号码哦~',
  confirm: '确认',
  excellent: '很满意',
  good: '满意',
  average: '一般',
  unsatisfactory: '不满意',
  selectAtLeastOne: '请至少选择一项哦~',
  submittedSuccessfully: '提交成功',
  submit: '提交',
  reSubmit: '重新提交',
  close: '关闭',
  note: '报名须知',
  understandNextStep: '已阅，下一步',
  nonMembers: '非会员：',
  individualMember: '个人会员：',
  organizationMember: '单位会员：',
  hotelExpense: '元，住宿定金：',
  rmb: '元',
  rmbPerson: '元/人',
  back: '返回',
  next: '下一步',
  email: '电子邮件',
  required: '注意事项：带*为必填项，请如实填写。',
  needHotel: '是否住宿',
  selectHotels: '选择酒店',
  reservation: '点击这里去预定房间',
  china: '中国',
  otherCountry: '其他国家',
  otherCountryName: '填写其他国家名称',
  phoneOrEmail: '电话/邮箱',
  phoneOrEmailHint: '请输入电话/邮箱',
  phoneOrEmailCannotBeEmpty: '电话/邮箱不能为空哦~',
  correctPhoneOrEmail: '请输入正确的电话/邮箱哦~',
  authentication: '身份验证',
  login: '登录',
  cancel: '取消',
  registrationNumber: '报名编号',
  conferencTopics: '报名主题',
  participant: '填表人',
  registrationPhoneOrEmail: '填表人手机号码/邮箱',
  status: '状态',
  status2: '状态',
  submissionTime: '提交时间',
  paymentStatus: '缴费状态',
  download: '下载',
  preview: '预览',
  location: '所在区域',
  companyName: '单位名称',
  companyCannotBeEmpty: '单位名称不能为空哦~',
  ids: '身份证/护照号码',
  documentTitle: '征文标题',
  documentTitleCannotBeEmpty: '征文标题不能为空哦~',
  authorName: '作者姓名',
  authorNameCannotBeEmpty: '作者姓名不能为空哦~',
  classification: '内容分类',
  uploadDocument: '上传征文',
  uploadVideo: '上传视频',
  uploadDocumentTips: '支持上传doc,docx格式的文档或图片，单个文件最大30M。',
  uploadVideoTips: '1.视频格式支持MP4，大小为500M以内。为保证视频播放效果，建议视频文件比例为16:9，分辨率为720P及以上。<br />2.若您的视频文件为非MP4格式或者大小超过500M，请先对视频进行格式转换或压缩处理，然后再上传。<br />3.视频文件上传需要一定时间，请耐心等待，上传成功后自动提交保存。<br />4.视频上传成功后，会延迟一定时间，才能预览播放。若页面提示“视频转码中”，请稍等5分钟左右。',
  uploadDocumentTips2: '请在“上传征文”处上传征文或图片',
  verificationCode: '验证码',
  verificationCodeHint: '请输入验证码',
  getVerificationCode: '获取验证码',
  agree: '点击按钮即表明您同意以上规则',
  submitTime: '提交时间',
  attachFile: '正文内容',
  downloadCertificate: '下载获奖证书',
  queryAwardResults: '征文查询',
  individualMemberVerification: '个人会员验证',
  organizationMemberVerification: '单位会员验证',
  ids2: '身份证号码',
  teamName: '单位名称',
  organizationCode: '组织机构代码或统一社会信用代码',
  signAgain: '重新输入签到信息',
  Information: '信息',
  verificationSuccessful: '验证成功',
  staffVerification: '请给会务人员进行确认，不要自行点击“确认”按钮',
  ConferencePass: '参会证',
  Organization: '单位',
  SignInTime: '签到时间',
  staff: '工作人员确认',
  warmPrompt: '温馨提示：',
  Confirmed: '确认成功，可正常参会！'
}
